var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.79 4.96999H17.15L10.16 11.96C9.98 12.14 9.88 12.39 9.88 12.64C9.88 12.89 9.98 13.14 10.16 13.32C10.34 13.5 10.58 13.6 10.84 13.6C11.1 13.6 11.34 13.5 11.52 13.32L18.52 6.32999V8.68999C18.52 9.21999 18.95 9.65999 19.48 9.65999C20.01 9.65999 20.45 9.22999 20.45 8.68999V4.00999C20.45 4.00999 20.45 3.91999 20.45 3.87999C20.45 3.81999 20.43 3.75999 20.41 3.70999C20.36 3.56999 20.28 3.42999 20.17 3.31999C20.07 3.21999 19.96 3.14999 19.83 3.09999C19.72 3.05999 19.6 3.03999 19.48 3.03999H14.79C14.26 3.03999 13.83 3.46999 13.83 4.00999C13.83 4.54999 14.26 4.97999 14.79 4.97999V4.96999Z",
    fill: "var(--icon-primary-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.52 12.9C18.99 12.9 18.56 13.33 18.56 13.87V18.56H4.93V4.92999H9.63C10.16 4.92999 10.59 4.49999 10.59 3.95999C10.59 3.41999 10.16 2.98999 9.63 2.98999H3.97C3.43 2.99999 3 3.42999 3 3.96999V19.53C3 20.06 3.43 20.49 3.97 20.49H19.53C20.06 20.49 20.5 20.06 20.5 19.53V13.87C20.5 13.34 20.07 12.9 19.53 12.9H19.52Z",
    fill: "var(--icon-primary-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExternalLink);
export default __webpack_public_path__ + "static/media/ic_external_link.c53de91d72a6d2cd9ade165310632f16.svg";
export { ForwardRef as ReactComponent };